import React, { useState, useEffect, useMemo } from "react";
import { withRouter } from "react-router-dom";
import { renderRoutes, matchRoutes } from "react-router-config";
import { connect } from "react-redux";
import { parse } from "query-string";
import { mapProperties, hydrateRoute } from "colbi_web_ui/lib/utils";
import { applyThemeWithPriority, GLOBAL_HEADER_HEIGHT, hasModule } from "../../utils/utils";
import HeaderNewNavigation from "../RawData/HeaderNewNavigation";
import Connect from "colbi_web_ui/lib/components/Connect";
import {
    asideRepositoryNavigationByModule,
    filteredNavigationByModulesForNestedLinks,
} from "../Repository/navigation";

import styles from "../RawData/RawData.module.sass";

import {
    logout,
    pushModal,
    pushDialog,
    popModal,
    uploadAction,
    downloadAction,
    toggleMenu,
    setLocale,
    auditNoteSubmit,
    removeModal,
    setDataFileStatusAction,
    deleteFilePermanentlyAction,
    deleteInvalidFilePermanentlyAction,
    hideFileAction,
    downloadFileAction,
    reprocessRepositoryAction,
    genericSearchAction,
    getFindingDetails,
    reprocessFileAction,
    getCustomCsvTablesAvailable,
    updateRowsActionCustomCsv,
} from "../../store/actions";
import I18n from "../../I18n";
import useUpdateThemes from "../../hooks/useUpdateThemes";

import proxy from "../../routes/proxy";
import {
    filteredQueriesByModules,
    filteredQueriesByModulesForMenu,
    getFirstModuleOfArray,
} from "../../routes/manageRouting";

import RepositoryStatus from "../../components/RepositoryStatus/RepositoryStatus";

import { mapPropertiesForMenu } from "../../utils";
import {
    decodeUserSession,
    redirectNotValid,
    buildStaticLinks,
} from "../../utils/utils";
import { cleanPropertiesNestedInMenu } from "../../utils/mapPropertiesForMenu";
import { buildNavProps, NewNavigationMenu } from "../utils/utils";
import { urlRedirectLink } from "../../utils/routingUtils";
import GlobalLayout from "../../components/GlobalLayout/GlobalLayout";
import {
    SovosBox,
    SovosCircularProgress,
    SovosSnackbar,
    SovosPageLayout,
    SovosPageContentGeneric,
    SovosTypography,
} from "mosaic-react";
import { useAuth } from "react-oidc-context";
import HeaderEditMode from "../RawData/Header/HeaderEditMode";
import {
    mapRawDataByLine,
    onCellHighlightDataGrid,
    onRowUpdateError,
} from "../RawData/utils";

const CustomCsvRawData = (props) => {
    const {
        modules,
        user,
        fetch,
        match,
        route,
        location,
        history,
        reload,
        getCustomCsvTablesAvailable,
        updateRowsActionCustomCsv,
    } = props;
    const { params: matchParams } = match || {};
    let { fiscalYear, importId } = matchParams;
    const { projectId, modulePrefix, locale = "en", entityRawData } = matchParams;
    const { results: fetchResults, status: fetchStatus } = fetch || {};
    const [editMode, setEditMode] = useState(false);
    const [topOffset, setTopOffset] = useState(GLOBAL_HEADER_HEIGHT);

    let rowsEdited = {};
    let listResults = [];
    let rawDataEdit = false;

    const auth = useAuth();

    const userInformation = decodeUserSession(user);

    const i18n = I18n.use(locale);

    const defaultNotification = { open: false, message: "", type: "", onClose: () => { } };
    const [notification, pushNotification] = useState({ ...defaultNotification });

    // --- viewMode state (read from URL query param) ---
    const queryParams = parse(location.search) || {};
    const viewMode = "source";

    const handleViewModeChange = (newViewMode) => {
        // Only allow Source mode for custom templates
        if (newViewMode === "legal") {
            // Disable Legal tab - keep on Source
            return;
        }
        const searchParams = new URLSearchParams(location.search);
        searchParams.set("viewMode", newViewMode);
        history.replace({
            pathname: location.pathname,
            search: `?${searchParams.toString()}`,
        });
    };

    const { menuOrganizationProject = [] } = mapProperties(
        {
            menuOrganizationProject: "query(0).list",
        },
        fetchResults,
        fetchStatus,
        CustomCsvRawData.queries(matchParams),
        props,
        matchParams,
        i18n,
        locale,
    );

    const { organizationProjects = {}, status } = mapProperties(
        {
            organizationProjects: "query(1)",
            status: "status(1)",
        },
        fetchResults,
        fetchStatus,
        CustomCsvRawData.queries(matchParams),
        props,
        matchParams,
        i18n,
        locale,
    );

    const { loading = true, success = false } = status || {};

    const { updateThemes, LoadingComponent } = useUpdateThemes(loading, success);

    // Apply theme with priority logic: Project > Organization > Default
    useEffect(() => {
        applyThemeWithPriority(organizationProjects, projectId, updateThemes, "CustomCsvRawData");
    }, [organizationProjects, projectId, updateThemes]);

    // --- Fetch custom CSV tables available ---
    const [customCsvTables, setCustomCsvTables] = useState([]);
    const [csvTablesLoaded, setCsvTablesLoaded] = useState(false);

    useEffect(() => {
        const header = document.querySelector('.sovosPageLayout header');
        if (header) {
            // 35px is the value set with-repository-banner
            const addValue = repoStatus ? 35 : 0
            setTopOffset(header.offsetHeight + addValue);
        }
        if (!projectId || !modulePrefix) return;

        setCsvTablesLoaded(false);
        getCustomCsvTablesAvailable(projectId, modulePrefix)
            .then((res) => {
                const { custom_csv_tables_available } = res;
                setCustomCsvTables((custom_csv_tables_available || []).map((t) => ({ id: t.id, name: t.name })));
                setCsvTablesLoaded(true);
            })
            .catch(() => {
                setCustomCsvTables([]);
                setCsvTablesLoaded(true);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projectId, modulePrefix, fiscalYear]);

    const customCsvTreeEntries = useMemo(() => {
        if (viewMode !== "source") {
            return []; // No items for Legal mode
        }

        const hasNewNavigation = hasModule(modules, "new_navigation");


        // Se new_navigation está ativo, retornar diretamente as tabelas sem wrapper
        if (hasNewNavigation) {
            return customCsvTables.map((table) => {
                return {
                    id: `CustomTemplates_${table.id}`,
                    content: table.name,
                    label: table.name,
                    key: "data",
                    viewMode: viewMode,
                    to: `/${locale}/${projectId}/${fiscalYear}/${importId}/custom_templates/${table.id}`,
                };
            });
        }

        // Legacy mode: Return same structure as raw_data: one parent "Custom Templates" with tables as nestedLinks
        return [
            {
                id: "CustomTemplates_0",
                label: "Custom Templates",
                useInMenuTreeList: true,
                viewMode: viewMode,
                nestedLinks: customCsvTables.map((table) => {
                    return {
                        id: `CustomTemplates_${table.id}`,
                        content: table.name,
                        label: table.name,
                        key: "data",
                        to: `/${locale}/${projectId}/${fiscalYear}/${importId}/custom_templates/${table.id}`,
                    };
                }),
            },
        ];
    }, [customCsvTables, viewMode, locale, projectId, fiscalYear, importId, modules]);

    const getTotalExportLines = fetchResults[`${locale}_get_limit_export`] || "";

    const project = organizationProjects
        ? (organizationProjects.projects || []).find(({ id }) => id === projectId) || {
            name: "",
        }
        : { name: "" };

    const { fiscalYears: projectFiscalYears } = project || {};

    const fiscalYears = Object.keys(projectFiscalYears || []);

    if (!fiscalYear && project && projectFiscalYears) {
        fiscalYear = fiscalYears.length > 0 ? Math.max(...fiscalYears) : "";
    }

    const fiscalYearsWithImportIds = projectFiscalYears || {};
    const importIdsFromUrlFiscalYear = fiscalYearsWithImportIds[fiscalYear];

    if (!importId && importIdsFromUrlFiscalYear && importIdsFromUrlFiscalYear.length) {
        const [maxImportId] = importIdsFromUrlFiscalYear;
        importId = maxImportId?.id;
    }

    const repositoryStatus = fetchResults[
        `${locale}_repository_status_fiscalYear_${fiscalYear}_projectId_${projectId}`
    ] || { status: 1 };

    const { repoStatus = 0 } = repositoryStatus

    useEffect(() => {
        if (repoStatus) {
            const addValue = repoStatus ? 35 : 0
            setTopOffset(GLOBAL_HEADER_HEIGHT + addValue);
        }
    }, [repoStatus]);

    const queriesForMenu = filteredQueriesByModulesForMenu(modules);
    const navData = mapPropertiesForMenu(
        queriesForMenu,
        fetchResults,
        locale,
        fiscalYear,
        projectId,
        importId,
    );

    const firstModuleFromProject = getFirstModuleOfArray(modules);
    const moduleConfigs = project
        ? (project.modules || []).find(({ name }) => name === firstModuleFromProject)
        : undefined;
    const importIdToUse =
        moduleConfigs && moduleConfigs.navigation_by_import_id ? importId : "full";

    const params = {
        ...(parse(location.search) || {}),
        ...(matchParams || {}),
    };

    const onRowEditDatagrid = (updatedRowObject, originalRowObject) => {
        const {
            audit_logs: updatedAuditLogs,
            oldRow: updatedOldRow,
            uniqueId: updatedUniqueID,
            ...updatedRow
        } = updatedRowObject;
        const {
            audit_logs: originalAuditLogs,
            oldRow: originalOldRow,
            uniqueId: originalUniqueID,
            ...originalRow
        } = originalRowObject;
        for (const key in updatedRow) {
            if (updatedRow[key] !== originalRow[key]) {
                const updateObject = {
                    [updatedRow.id]: {
                        updated: {
                            [`${key}`]: updatedRow[key],
                            ...rowsEdited[updatedRow.id]?.updated,
                        },
                        original: rowsEdited[updatedRow.id]?.original
                            ? rowsEdited[updatedRow.id]?.original
                            : originalRow,
                    },
                };
                rowsEdited = { ...rowsEdited, ...updateObject };
            }
        }
        return { ...updatedRow, uniqueId: updatedUniqueID };
    };

    const routeQueries = (route.queries && route.queries(params)) || [];
    // Only create children (DataGrid) when entityRawData is present
    const children = entityRawData && route.components ? route.components.map((c, index) => {
        const Component = c.component;
        const componentParsedProps = mapProperties(
            c.props,
            fetchResults,
            fetchStatus,
            routeQueries,
            props,
            params,
            i18n,
            locale,
        );

        const customRawDataView =
            componentParsedProps?.items?.length && componentParsedProps?.header?.length
                ? mapRawDataByLine(
                    componentParsedProps.items,
                    componentParsedProps.header,
                    entityRawData,
                    projectId,
                    fiscalYear,
                    importId,
                    modulePrefix,
                )
                : [];
        const componentProps = {
            ...componentParsedProps,
            header: componentParsedProps.header,
            items: customRawDataView,
            modules,
            editMode: editMode,
        };
        if (componentProps && componentProps.items?.length && componentProps.cellHighlight) {
            componentProps.modifierssx = {
                "& .highlight": {
                    backgroundColor: "#E0EAF8",
                },
            };
            componentProps.onCellHighlight = (params) => onCellHighlightDataGrid(params);
        }
        if (componentProps && componentProps.items?.length && componentProps.onRowEdit) {
            componentProps.onProcessRowUpdateErrorAction = () =>
                onRowUpdateError(pushNotification, I18n);
            componentProps.onRowEdit = (updatedRow, originalRow) =>
                onRowEditDatagrid(updatedRow, originalRow);
        }

        rawDataEdit = componentParsedProps.rawDataEdit || false;
        listResults = componentProps.items || [];
        return (
            <Component
                key={index}
                modifiers={c.modifiers}
                {...componentProps}
                activity={fetch.activity}
            />
        );
    }) : [];

    const branch = matchRoutes([route, ...(route.routes || [])], location.pathname);
    const branchQueries = branch.reduce((allQueries, { route }) => {
        const innerQueries = route.queries ? route.queries(params) : [];
        allQueries = [...innerQueries];
        return allQueries;
    }, []);

    const downloadableQueries = branchQueries?.filter(({ downloadable }) => downloadable);

    const repositoryNavigation = filteredNavigationByModulesForNestedLinks(
        modules || [],
        asideRepositoryNavigationByModule,
    );

    const _navigation = (route.navigation || []).map((item) => {
        if (item?.name === "label(Repository)") {
            delete item.to;
            item.navigation = [...repositoryNavigation];
        }

        return item;
    });

    const { navigation } = mapProperties(
        { navigation: _navigation },
        fetchResults,
        fetchStatus,
        CustomCsvRawData.queries({ ...params, fiscalYear, importId }),
        {
            ...props,
            ...navData,
        },
        { ...params, fiscalYear, importId },
        i18n,
        locale,
    );

    //TODO Pass this to an util and take into account fetch.activity
    const isPageLoading = (status, activity) => {
        return (
            activity ||
            activity === null ||
            Object.keys(status).some((queryKey) => {
                return status[queryKey].loading === true;
            })
        );
    };

    const redirect = redirectNotValid(userInformation, locale, false, auth);

    if (redirect) {
        return redirect;
    }

    if (!projectId) {
        return urlRedirectLink(`${locale ? `/${locale}` : ""}/`);
    }

    if (!fiscalYear && !importId && !fiscalYears.length) {
        return urlRedirectLink(
            `${locale ? `/${locale}` : "/en"}/${projectId}/0000/full/repository/activity`,
        );
    }

    if (fiscalYear === "0000" && fiscalYears.length) {
        const to = hydrateRoute(match.path, {
            ...matchParams,
            fiscalYear: Math.max(...fiscalYears),
            importId: importIdToUse,
            firstModuleFromProject,
        });

        if (to !== match.url && !to.match(/\*$/)) {
            return urlRedirectLink(to);
        }
    }

    if (
        fiscalYear &&
        importIdToUse &&
        !isNaN(Number(matchParams.fiscalYear)) &&
        !isNaN(Number(matchParams.importId)) &&
        fiscalYear !== matchParams.fiscalYear &&
        importIdToUse !== matchParams.importId &&
        firstModuleFromProject
    ) {
        const to = hydrateRoute(match.path, {
            ...matchParams,
            fiscalYear,
            importId: importIdToUse,
            firstModuleFromProject,
        });

        if (to !== match.url && !to.match(/\*$/)) {
            return urlRedirectLink(to);
        }
    }

    // Redirect to add viewMode=source if missing
    if (!queryParams.viewMode) {
        const searchParams = new URLSearchParams(location.search);
        searchParams.set("viewMode", "source");
        return urlRedirectLink(`${location.pathname}?${searchParams.toString()}`);
    }

    const { navProps, staticLinks, leftMenuStaticLinks, hasNewNavigation } = buildNavProps(
        buildStaticLinks,
        navigation,
        history,
        matchParams,
        fiscalYear,
        importId,
        i18n,
        menuOrganizationProject,
        projectId,
        cleanPropertiesNestedInMenu,
        locale,
        proxy,
        params,
        userInformation,
        modules,
        viewMode,
    );

    const globalLayoutProps = {
        ...props,
        navProps,
        downloadableQueries,
        params: { ...params, fiscalYear, importId },
        repositoryStatus,
        getTotalExportLines,
        staticLinks,
        styles,
        organizationProjects,
        leftMenuStaticLinks: hasNewNavigation ? leftMenuStaticLinks : [],
    };

    const saveRawData = (e) => {
        updateRowsActionCustomCsv(projectId, entityRawData, JSON.stringify(rowsEdited))
            .then((res) => {
                if (!res?.update_rows_custom_csv_raw_data) {
                    onRowUpdateError(pushNotification, I18n);
                    return;
                }
                pushNotification({
                    open: true,
                    message: I18n.translate`Your edit have been saved successfully`,
                    type: "confirmation",
                    timeout: "short",
                });
                setEditMode(false);
                reload && reload();
            })
            .catch(() => {
                onRowUpdateError(pushNotification, I18n);
            });
    };

    const title = i18n`Custom Source Data`;
    const titleBarActions = entityRawData ? [
        <HeaderEditMode
            key="edit-mode"
            editMode={editMode}
            setEditMode={setEditMode}
            onClickSave={saveRawData}
            params={params}
            list={listResults}
            rawDataEdit={rawDataEdit}
        />,
    ] : undefined;

    return (
        LoadingComponent || (
            <GlobalLayout {...globalLayoutProps}>
                <SovosPageLayout
                    className={repoStatus ? `${styles["with-repository-banner"]}` : ""}
                    pageTitle={title || ""}
                    titleBarActions={titleBarActions}>
                    <RepositoryStatus modules={modules} />
                    <SovosPageContentGeneric
                        sx={{
                            padding: "0 !important",
                            marginLeft: "0",
                            marginRight: "24px",
                            height: "100%",
                            paddingTop: "49px !important"
                        }}
                    >
                        <SovosBox sx={{ position: "absolute", top: topOffset, left: 0, right: 0, overflowX: "hidden" }}>
                            <Connect to={["search", "downloading"]}>
                                {() => (
                                    <HeaderNewNavigation
                                        fiscalYears={null}
                                        importIds={null}
                                        viewMode={viewMode}
                                        onViewModeChange={handleViewModeChange}
                                        disableLegalTab={true}
                                        hideFiscalYearSelector={true}
                                    />
                                )}
                            </Connect>
                        </SovosBox>
                        <SovosBox
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                height: "100%",
                                width: "100%",
                            }}
                        >
                            {/* Left sidebar tree — same component as structured data */}
                            <NewNavigationMenu
                                menuEntries={customCsvTreeEntries}
                                history={history}
                                viewMode={viewMode}
                                flatList={true}
                                loading={!csvTablesLoaded}
                            />
                            {/* Right content area — loading only affects this area */}
                            <SovosBox sx={{ flex: 1, overflow: "auto" }}>
                                {isPageLoading(fetch?.status, fetch?.activity) ? (
                                    <SovosBox
                                        sx={{
                                            flex: 1,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            height: "100%",
                                        }}
                                    >
                                        <SovosCircularProgress aria-label={"Loading"} />
                                    </SovosBox>
                                ) : entityRawData ? (
                                    <>
                                        {children}
                                        {renderRoutes(route.routes)}
                                    </>
                                ) : (
                                    <SovosBox
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            height: "100%",
                                            padding: "48px",
                                        }}
                                    >
                                        <SovosTypography variant="body1" sx={{ color: "text.secondary" }}>
                                            {i18n`Select a table from the menu to view its data.`}
                                        </SovosTypography>
                                    </SovosBox>
                                )}
                                <SovosSnackbar
                                    onClose={() => {
                                        pushNotification({
                                            ...notification,
                                            open: false,
                                        });
                                    }}
                                    message={notification && notification.message}
                                    open={notification && notification.open}
                                    variant={
                                        notification && notification.type
                                            ? notification.type
                                            : "confirmation"
                                    }
                                    timeout={
                                        notification && notification.timeout
                                            ? notification.timeout
                                            : "medium"
                                    }
                                    disableWindowBlurListener
                                />
                            </SovosBox>
                        </SovosBox>
                    </SovosPageContentGeneric>
                </SovosPageLayout>
            </GlobalLayout>
        )
    );
};

CustomCsvRawData.queries = (args, userModulesByProject) => {
    const queries = filteredQueriesByModules(userModulesByProject);
    const deepCopyQueries = JSON.parse(JSON.stringify(queries));
    if (deepCopyQueries) {
        //needed to change arguments to the respective value
        deepCopyQueries.forEach((query) =>
            Object.keys(query.args).forEach((k) =>
                query.args[k] ? query.args[k] : (query.args[k] = args[k] || query.args[k]),
            ),
        );
    }

    const allQueries = [
        {
            resource: "menu_organizations_projects",
            body: "id,name,typeEntity,nestedAccounts{id,name,typeEntity}",
            forceRefresh: true,
        },
        {
            resource: "organization_projects_by_projectId",
            args: {
                projectId: args.projectId,
            },
            body: "id,name,maxFiscalYear,fiscalYears,calendarYears,mosaicThemeConfig,projects{id,name,fiscalYears,status,taxRegistrationNumber,active,projectExpired,metadata,mosaicThemeConfig,modules{navigation_by_import_id,name,default_route,default_module}},organizationExpired, organizationActive, maxFiscalYear",
            forceRefresh: true,
        },
        {
            resource: "custom_csv_raw_data",
            args: {
                entity: args.entityRawData || "",
                projectId: args.projectId,
                fiscalYear: args.fiscalYear,
                importId: args.importId,
            },
            body: "items,headerItems,metadata{total},rawDataEdit",
            isDatagridReq: true,
        },
    ];

    return [...allQueries, ...deepCopyQueries];
};

export default connect(
    (state) => ({
        user: state.user,
        fetch: state.fetch,
    }),
    {
        logout,
        pushModal,
        pushDialog,
        popModal,
        uploadAction,
        downloadAction,
        toggleMenu,
        setLocale,
        auditNoteSubmit,
        removeModal,
        setDataFileStatusAction,
        deleteFilePermanentlyAction,
        deleteInvalidFilePermanentlyAction,
        hideFileAction,
        downloadFileAction,
        reprocessRepositoryAction,
        genericSearchAction,
        getFindingDetails,
        reprocessFileAction,
        getCustomCsvTablesAvailable,
        updateRowsActionCustomCsv,
    },
)(withRouter(CustomCsvRawData));

